document.addEventListener('DOMContentLoaded', async () => {
  if (document.querySelector('.c-icon')) {
    await import('@fortawesome/fontawesome-free/js/fontawesome');
    await import('@fortawesome/fontawesome-free/js/solid');
  }

  await import('./Component/Splash/Splash');
  await import('./Override/usercentrics');

  if (!document.body.classList.contains('neos-backend')) {
    animateNodeTypes();
  }

  if (document.querySelector('#main-header')) {
    const { initHeader } = await import('./Component/Header/Header');
    initHeader();
  }

  if (document.querySelector('.c-slider')) {
    const { initSliders } = await import('./Content/Slider/Slider');
    initSliders();
  }

  if (document.querySelector('.c-page-tiles')) {
    const { initPageTiles } = await import('./Content/PageTiles/PageTiles');
    initPageTiles();
  }

  if (document.querySelector('.c-logos')) {
    const { initLogos } = await import('./Content/Logos/Logos');
    initLogos();
  }

  if (document.querySelector('.c-flip-tiles')) {
    const { initFlipTiles } = await import('./Content/FlipTiles/FlipTiles');
    initFlipTiles();
  }

  if (document.querySelector('.c-gallery')) {
    const { initGalleries } = await import('./Content/Gallery/Gallery');
    initGalleries();
  }

  if (document.querySelector('.c-employee')) {
    const { initEmployees } = await import(
      './Content/Employees/Employee/Employee'
    );
    initEmployees();
  }

  if (document.querySelector('.c-accordion')) {
    const { initAccordions } = await import('./Content/Accordion/Accordion');
    initAccordions();
  }

  if (document.querySelector('.employee-back-btn')) {
    const { initEmployeePage } = await import(
      './Document/EmployeePage/EmployeePage'
    );
    initEmployeePage();
  }

  if (document.querySelector('.c-contact-form')) {
    const { initContactForm } = await import(
      './Content/ContactForm/ContactForm'
    );
    initContactForm();
  }
});

function animateNodeTypes() {
  if (document.body.classList.contains('neos-backend')) return;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(
      (entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-up');
          observer.unobserve(entry.target);
        }
      },
      {
        // Start observing when the element is at least 10% in the viewport
        rootMargin: '-10% 0px -90% 0px',
      }
    );
  });

  const tiles = document.querySelectorAll('#main-content .nodetype, .c-tile');

  for (const tile of tiles) {
    if (tile.getBoundingClientRect().top > window.innerHeight) {
      observer.observe(tile);
    }
  }
}
